// Implements: F-IDN-010, F-UIX-009
/**
 * Above the session table (v3 `acctSessions`): how many sessions are open, that the place is an
 * estimate from the address, and "Cerrar las demás sesiones", disabled with its reason when this
 * device is the only one. Pure presentation.
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import { Button } from "../../../shared/ui/atoms/Button";
import { Icon } from "../../../shared/ui/atoms/Icon";
import shared from "./account.module.css";

export interface SessionsToolbarProps {
  readonly total: number;
  readonly others: number;
  readonly busy: boolean;
  readonly onRevokeOthers: () => void;
}

export function SessionsToolbar({ total, others, busy, onRevokeOthers }: SessionsToolbarProps): ReactElement {
  const { t } = useTranslation();
  const none = others === 0;
  return (
    <div className={shared.toolbar}>
      <span className={shared.meta}>
        {total === 1 ? t("account.sessions.countOne") : t("account.sessions.countMany", { count: total })}
      </span>
      <span className={shared.spacer} />
      <span title={none ? t("account.sessions.noOthers") : undefined}>
        <Button variant="danger" hasPopup="dialog" disabled={none || busy} loading={busy} onClick={onRevokeOthers}>
          <Icon name="logout" size="sm" />
          {t("account.sessions.revokeOthers")}
        </Button>
      </span>
    </div>
  );
}
